// extracted by mini-css-extract-plugin
export default {"Box":"nav_Box__ls3-k","container":"nav_container__+Lkhj","container2":"nav_container2__6ppT9","flex":"nav_flex__sLHvN","btton":"nav_btton__R9MCW"};